import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { StationsPageHeaderProps } from './StationsPageHeader.types';

/**
 * Renders page header with back navigation and title
 */
export const StationsPageHeader = ({ title, backPath, backLabel, isMobile, onNavigate }: StationsPageHeaderProps) => {
  return (
    <div className="page-header">
      <Button startIcon={<ArrowBack />} onClick={() => onNavigate(backPath)} className="back-button">
        {isMobile ? 'Назад' : backLabel}
      </Button>
      <h2 className="page-title">{title}</h2>
    </div>
  );
};
